<script setup>
defineProps({
  label: {
    type: String,
    required: true
  },
  sublabel: {
    type: String,
    default: ''
  },
  variant: {
    type: String,
    default: 'default',
    validator: (value) => ['default', 'success', 'accent'].includes(value)
  }
})

const variantClasses = {
  default: 'bg-accent-50 text-accent-700',
  success: 'bg-green-50 text-green-700 border border-green-200',
  accent: 'bg-accent-100 text-accent-800'
}

const dotClasses = {
  default: 'bg-accent-500',
  success: 'bg-green-500',
  accent: 'bg-accent-600'
}

const sublabelClasses = {
  default: 'bg-white text-accent-600',
  success: 'bg-white text-green-600',
  accent: 'bg-white text-accent-700'
}
</script>

<template>
  <div
    class="inline-flex items-center gap-3 px-4 py-2 rounded-full"
    :class="variantClasses[variant]"
  >
    <span
      class="w-2 h-2 rounded-full"
      :class="dotClasses[variant]"
    ></span>
    <span class="text-sm font-medium">{{ label }}</span>
    <span
      v-if="sublabel"
      class="text-xs px-2 py-0.5 rounded-full"
      :class="sublabelClasses[variant]"
    >
      {{ sublabel }}
    </span>
  </div>
</template>
